module.exports = __webpack_public_path__ + "img/40_38_036_530.ac3a12b4.jpg";